// App.js
import React, { useState, useEffect } from 'react';
import './App.css';

// MBTI 질문 데이터
const mbtiQuestions = [
  // E vs I 질문 (5개)
  { 
    id: 1, 
    text: "모임에서 새로운 사람들과 대화를 시작하는 것이 편하다.", 
    dimension: "EI",
    forType: "E" 
  },
  { 
    id: 2, 
    text: "여러 사람들과 함께 있을 때보다 혼자 있을 때 더 편안함을 느낀다.", 
    dimension: "EI",
    forType: "I" 
  },
  { 
    id: 3, 
    text: "대체로 먼저 말을 꺼내는 편이다.", 
    dimension: "EI",
    forType: "E" 
  },
  { 
    id: 4, 
    text: "깊이 있는 대화를 여러 사람과의 가벼운 대화보다 선호한다.", 
    dimension: "EI",
    forType: "I" 
  },
  { 
    id: 5, 
    text: "활동적인 사교 모임에서 에너지를 얻는다.", 
    dimension: "EI",
    forType: "E" 
  },
  
  // S vs N 질문 (5개)
  { 
    id: 6, 
    text: "추상적인 개념이나 이론보다 구체적인 사실과 세부사항에 더 집중한다.", 
    dimension: "SN",
    forType: "S" 
  },
  { 
    id: 7, 
    text: "미래의 가능성에 대해 생각하는 것을 즐긴다.", 
    dimension: "SN",
    forType: "N" 
  },
  { 
    id: 8, 
    text: "실용적이고 현실적인 해결책을 선호한다.", 
    dimension: "SN",
    forType: "S" 
  },
  { 
    id: 9, 
    text: "새로운 아이디어와 가능성을 탐색하는 것을 좋아한다.", 
    dimension: "SN",
    forType: "N" 
  },
  { 
    id: 10, 
    text: "경험과 관찰을 통해 배우는 것을 선호한다.", 
    dimension: "SN",
    forType: "S" 
  },
  
  // T vs F 질문 (5개)
  { 
    id: 11, 
    text: "결정을 내릴 때 감정보다 논리를 더 중요시한다.", 
    dimension: "TF",
    forType: "T" 
  },
  { 
    id: 12, 
    text: "다른 사람의 감정을 고려하는 것이 중요하다고 생각한다.", 
    dimension: "TF",
    forType: "F" 
  },
  { 
    id: 13, 
    text: "객관적인 분석을 통해 결정을 내리는 경향이 있다.", 
    dimension: "TF",
    forType: "T" 
  },
  { 
    id: 14, 
    text: "조화로운 환경과 관계를 유지하는 것이 매우 중요하다.", 
    dimension: "TF",
    forType: "F" 
  },
  { 
    id: 15, 
    text: "감정적인 요소보다 사실과 진실을 더 중요시한다.", 
    dimension: "TF",
    forType: "T" 
  },
  
  // J vs P 질문 (5개)
  { 
    id: 16, 
    text: "계획을 세우고 그대로 따르는 것을 선호한다.", 
    dimension: "JP",
    forType: "J" 
  },
  { 
    id: 17, 
    text: "계획보다는 상황에 따라 유연하게 대처하는 것을 좋아한다.", 
    dimension: "JP",
    forType: "P" 
  },
  { 
    id: 18, 
    text: "체계적으로 일을 처리하며 마감 기한을 중요시한다.", 
    dimension: "JP",
    forType: "J" 
  },
  { 
    id: 19, 
    text: "새로운 정보와 가능성에 열려있으며 결정을 미루는 경향이 있다.", 
    dimension: "JP",
    forType: "P" 
  },
  { 
    id: 20, 
    text: "일을 시작하기 전에 계획을 세우는 것이 중요하다.", 
    dimension: "JP",
    forType: "J" 
  }
];

// MBTI 유형 설명 데이터
const mbtiDescriptions = {
  ISTJ: {
    title: "청렴결백한 논리주의자 (ISTJ)",
    description: "사실을 중시하는 믿음직한 현실주의자입니다. 체계적이고 책임감이 강하며, 안정성과 질서를 중요시합니다. 논리적이고 끈기 있게 일을 처리하며 전통과 충성을 중요하게 생각합니다.",
    strengths: ["체계적", "책임감이 강함", "정직함", "실용적", "논리적"],
    weaknesses: ["융통성 부족", "변화에 저항", "감정 표현에 어려움", "지나치게 엄격할 수 있음"]
  },
  ISFJ: {
    title: "용감한 수호자 (ISFJ)",
    description: "헌신적이고 따뜻한 수호자입니다. 세심하고 책임감이 강하며 다른 사람의 필요에 민감합니다. 전통과 안정을 중요시하며 조용히 다른 사람을 돕는 것을 좋아합니다.",
    strengths: ["충실함", "헌신적", "세심함", "실용적", "안정적"],
    weaknesses: ["자기 희생적", "변화에 적응하기 어려움", "비판에 민감", "자신의 필요를 무시하는 경향"]
  },
  INFJ: {
    title: "선의의 옹호자 (INFJ)",
    description: "이상주의적이고 원칙적인 사람입니다. 깊은 통찰력과 창의성을 가지고 있으며, 타인과 깊은 연결을 추구합니다. 조용하지만 강한 신념을 가지고 있으며 사회적 가치와 인류애에 관심이 많습니다.",
    strengths: ["창의적", "통찰력이 있음", "원칙적", "열정적", "이타적"],
    weaknesses: ["완벽주의", "번아웃 위험", "비현실적 기대", "비판에 민감"]
  },
  INTJ: {
    title: "용의주도한 전략가 (INTJ)",
    description: "혁신적인 전략가이자 분석가입니다. 독립적이고 논리적이며 복잡한 문제를 해결하는 능력이 뛰어납니다. 비전과 시스템적 사고를 통해 장기적인 계획을 수립하는 것을 좋아합니다.",
    strengths: ["전략적 사고", "독립적", "논리적", "결단력", "지식 추구"],
    weaknesses: ["냉담해 보일 수 있음", "지나친 완벽주의", "비판적", "사회적 기술이 부족할 수 있음"]
  },
  ISTP: {
    title: "만능 재주꾼 (ISTP)",
    description: "논리적이고 실용적인 문제 해결사입니다. 호기심이 많고 관찰력이 뛰어나며 기계적인 것에 관심이 많습니다. 효율성을 중시하고 위기 상황에서 침착하게 대처할 수 있습니다.",
    strengths: ["적응력", "문제 해결 능력", "실용적", "독립적", "관찰력"],
    weaknesses: ["충동적일 수 있음", "장기적 계획 부족", "감정 표현에 서툼", "규칙에 구애받지 않음"]
  },
  ISFP: {
    title: "호기심 많은 예술가 (ISFP)",
    description: "민감하고 친절한 창작자입니다. 조용하고 겸손하지만 열정적이며, 자유와 개인적 가치를 중요시합니다. 현재에 충실하며 감각적인 경험과 아름다움을 추구합니다.",
    strengths: ["창의적", "충실함", "적응력", "조화로움", "감수성이 풍부함"],
    weaknesses: ["갈등 회피", "장기 계획 부족", "쉽게 스트레스 받음", "지나치게 독립적일 수 있음"]
  },
  INFP: {
    title: "열정적인 중재자 (INFP)",
    description: "이상주의적이고 창의적인 중재자입니다. 깊은 감정과 개인적 가치를 중요시하며, 타인의 잠재력을 발견하고 성장을 돕는 것을 좋아합니다. 조화와 진정성을 추구합니다.",
    strengths: ["이상주의적", "창의적", "적응력", "열정적", "충실함"],
    weaknesses: ["비현실적일 수 있음", "자기 비판적", "실용성 부족", "외부 세계와 단절될 수 있음"]
  },
  INTP: {
    title: "논리적인 사색가 (INTP)",
    description: "혁신적인 발명가이자 지식 탐구자입니다. 논리적이고 객관적이며 복잡한 이론과 아이디어에 관심이 많습니다. 독창적인 사고와 지적 호기심이 강하며 효율적인 시스템을 설계하는 것을 좋아합니다.",
    strengths: ["논리적", "창의적", "객관적", "분석적", "지적 호기심"],
    weaknesses: ["과도한 분석", "실행에 어려움", "사회적 기술 부족", "현실과 괴리될 수 있음"]
  },
  ESTP: {
    title: "모험을 즐기는 사업가 (ESTP)",
    description: "활동적이고 적응력이 뛰어난 현실주의자입니다. 실용적이고 즉흥적이며 문제 해결에 직접적인 접근 방식을 선호합니다. 위험을 감수하고 새로운 경험을 추구하는 경향이 있습니다.",
    strengths: ["적응력", "실용적", "현실주의자", "문제 해결 능력", "에너지 넘침"],
    weaknesses: ["충동적", "위험을 감수함", "장기 계획 부족", "세부사항 놓칠 수 있음"]
  },
  ESFP: {
    title: "자유로운 영혼의 연예인 (ESFP)",
    description: "열정적이고 사교적인 연예인 타입입니다. 현재에 충실하고 즐거움을 추구하며, 다른 사람들의 삶에 활력을 불어넣습니다. 실용적이고 적응력이 좋으며 새로운 경험을 좋아합니다.",
    strengths: ["열정적", "친절함", "적응력", "실용적", "창의적"],
    weaknesses: ["계획성 부족", "장기적 목표 설정 어려움", "갈등 회피", "쉽게 지루해함"]
  },
  ENFP: {
    title: "재기발랄한 활동가 (ENFP)",
    description: "열정적이고 창의적인 자유 영혼입니다. 가능성과 새로운 아이디어에 흥분하며, 다양한 관심사와 재능을 가지고 있습니다. 사람들과 쉽게 연결되며 긍정적인 에너지를 전파합니다.",
    strengths: ["열정적", "창의적", "사교적", "적응력", "직관적"],
    weaknesses: ["집중력 부족", "완성도 문제", "계획성 부족", "과도한 이상주의"]
  },
  ENTP: {
    title: "논쟁을 즐기는 변론가 (ENTP)",
    description: "창의적이고 지적인 도전자입니다. 새로운 아이디어와 개념에 호기심이 많으며, 다양한 관점에서 문제를 분석하는 것을 좋아합니다. 민첩한 두뇌와 논리적 사고로 혁신적인 해결책을 찾아냅니다.",
    strengths: ["창의적", "지적 호기심", "유연한 사고", "적응력", "논리적"],
    weaknesses: ["논쟁적", "일상적인 업무에 지루해함", "집중력 문제", "감정적 필요 간과"]
  },
  ESTJ: {
    title: "엄격한 관리자 (ESTJ)",
    description: "실용적이고 사실적인 관리자입니다. 체계적이고 책임감이 강하며, 효율성과 결과를 중요시합니다. 명확한 규칙과 절차를 선호하며 목표 달성을 위해 노력합니다.",
    strengths: ["체계적", "책임감", "결단력", "효율적", "실용적"],
    weaknesses: ["융통성 부족", "감정에 둔감할 수 있음", "지나치게 통제적", "변화에 저항"]
  },
  ESFJ: {
    title: "사교적인 외교관 (ESFJ)",
    description: "배려심이 많고 사교적인 보살핌 제공자입니다. 조화로운 환경을 만들고자 하며, 다른 사람들의 필요와 감정에 민감합니다. 전통과 안정을 중요시하며 실용적인 도움을 제공합니다.",
    strengths: ["사교적", "세심함", "협력적", "배려심", "책임감"],
    weaknesses: ["비판에 민감", "과도한 걱정", "자기 자신을 희생", "변화에 적응하기 어려움"]
  },
  ENFJ: {
    title: "정의로운 사회운동가 (ENFJ)",
    description: "카리스마 있고 영감을 주는 지도자입니다. 타인의 성장과 발전을 돕는 것에 열정적이며, 공동체와 조화를 중요시합니다. 공감 능력이 뛰어나고 사람들의 잠재력을 끌어내는 데 재능이 있습니다.",
    strengths: ["공감 능력", "영감을 주는", "카리스마", "헌신적", "조직력"],
    weaknesses: ["자기 비판적", "피로함", "갈등 회피", "지나치게 이상주의적"]
  },
  ENTJ: {
    title: "대담한 통솔자 (ENTJ)",
    description: "전략적이고 결단력 있는 지도자입니다. 논리적이고 효율적인 시스템을 구축하는 데 탁월하며, 장기적인 목표와 비전을 향해 나아갑니다. 결단력이 강하고 지식과 능력을 중요시합니다.",
    strengths: ["전략적 사고", "리더십", "결단력", "논리적", "효율적"],
    weaknesses: ["지배적일 수 있음", "감정에 둔감할 수 있음", "인내심 부족", "너무 직설적"]
  }
};

function App() {
  const [step, setStep] = useState('intro'); // intro, questions, result
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [result, setResult] = useState(null);
  const [fadeIn, setFadeIn] = useState(true);

  // LocalStorage에서 이전 테스트 결과 로드
  useEffect(() => {
    const savedResult = localStorage.getItem('mbtiResult');
    const savedAnswers = localStorage.getItem('mbtiAnswers');
    
    if (savedResult) {
      setResult(JSON.parse(savedResult));
    }
    
    if (savedAnswers) {
      setAnswers(JSON.parse(savedAnswers));
    }
  }, []);

  // 단계 변경 함수 (애니메이션 효과 포함)
  const changeStep = (newStep) => {
    setFadeIn(false);
    setTimeout(() => {
      setStep(newStep);
      setFadeIn(true);
    }, 300);
  };

  // 테스트 시작
  const startTest = () => {
    setAnswers({});
    setResult(null);
    setCurrentQuestion(0);
    localStorage.removeItem('mbtiResult');
    localStorage.removeItem('mbtiAnswers');
    changeStep('questions');
  };

  // 질문에 답변
  const answerQuestion = (value) => {
    const question = mbtiQuestions[currentQuestion];
    const newAnswers = { ...answers, [question.id]: value };
    setAnswers(newAnswers);
    
    // LocalStorage에 답변 저장
    localStorage.setItem('mbtiAnswers', JSON.stringify(newAnswers));
    
    if (currentQuestion < mbtiQuestions.length - 1) {
      // 다음 질문으로
      setFadeIn(false);
      setTimeout(() => {
        setCurrentQuestion(currentQuestion + 1);
        setFadeIn(true);
      }, 300);
    } else {
      // 결과 계산
      calculateResult(newAnswers);
    }
  };

  // MBTI 결과 계산
  const calculateResult = (answers) => {
    const scores = {
      E: 0, I: 0,
      S: 0, N: 0,
      T: 0, F: 0,
      J: 0, P: 0
    };
    
    // 각 답변에 대한 점수 계산
    Object.entries(answers).forEach(([questionId, value]) => {
      const question = mbtiQuestions.find(q => q.id === parseInt(questionId));
      if (question) {
        const type = question.forType;
        const oppType = {E: 'I', I: 'E', S: 'N', N: 'S', T: 'F', F: 'T', J: 'P', P: 'J'}[type];
        
        // 각 질문의 값(1-5)에 따라 점수 할당
        // 높은 값은 해당 타입에 더 가까움을 의미
        if (value >= 3) {
          scores[type] += (value - 2);
        } else {
          scores[oppType] += (4 - value);
        }
      }
    });
    
    // 최종 MBTI 유형 결정
    const mbtiResult = [
      scores.E > scores.I ? 'E' : 'I',
      scores.S > scores.N ? 'S' : 'N',
      scores.T > scores.F ? 'T' : 'F',
      scores.J > scores.P ? 'J' : 'P'
    ].join('');
    
    const dimensionScores = {
      EI: { E: scores.E, I: scores.I, result: scores.E > scores.I ? 'E' : 'I' },
      SN: { S: scores.S, N: scores.N, result: scores.S > scores.N ? 'S' : 'N' },
      TF: { T: scores.T, F: scores.F, result: scores.T > scores.F ? 'T' : 'F' },
      JP: { J: scores.J, P: scores.P, result: scores.J > scores.P ? 'J' : 'P' }
    };
    
    const finalResult = {
      type: mbtiResult,
      dimensionScores,
      description: mbtiDescriptions[mbtiResult]
    };
    
    setResult(finalResult);
    localStorage.setItem('mbtiResult', JSON.stringify(finalResult));
    changeStep('result');
  };

  // 진행률 계산
  const calculateProgress = () => {
    return ((currentQuestion + 1) / mbtiQuestions.length) * 100;
  };

  // 현재 질문 차원 반환
  const getCurrentDimension = () => {
    if (currentQuestion < 5) return "외향성 vs 내향성";
    if (currentQuestion < 10) return "감각 vs 직관";
    if (currentQuestion < 15) return "사고 vs 감정";
    return "판단 vs 인식";
  };

  return (
    <div className="app-container">
      <div className={`content-card ${fadeIn ? 'fade-in' : 'fade-out'}`}>
        {step === 'intro' && (
          <div className="section-padding text-center">
            <h1 className="title">MBTI 성격 유형 테스트</h1>
            <p className="subtitle">자신의 성격 유형을 알아보세요. 20개의 간단한 질문에 답하고 나의 MBTI 유형을 확인하세요.</p>
            
            {result && (
              <div className="previous-result">
                <p className="previous-result-text">이전 테스트 결과: <span className="font-bold text-indigo-600">{result.type}</span></p>
                <button 
                  onClick={() => changeStep('result')} 
                  className="result-link"
                >
                  결과 다시 보기
                </button>
              </div>
            )}
            
            <button 
              onClick={startTest} 
              className="btn btn-primary"
            >
              테스트 시작하기
            </button>
          </div>
        )}
        
        {step === 'questions' && (
          <div className="section-padding">
            <div className="progress-container">
              <div className="progress-header">
                <span className="progress-text">{getCurrentDimension()}</span>
                <span className="progress-text">{currentQuestion + 1} / {mbtiQuestions.length}</span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-bar-fill" 
                  style={{ width: `${calculateProgress()}%` }}
                />
              </div>
            </div>
            
            <div>
              <h2 className="question-text">{mbtiQuestions[currentQuestion].text}</h2>
              
              <div className="answer-options">
                {[5, 4, 3, 2, 1].map((value) => {
                  let label;
                  if (value === 5) label = "매우 그렇다";
                  else if (value === 4) label = "그렇다";
                  else if (value === 3) label = "보통이다";
                  else if (value === 2) label = "아니다";
                  else label = "전혀 아니다";
                  
                  return (
                    <button
                      key={value}
                      onClick={() => answerQuestion(value)}
                      className="answer-option"
                    >
                      {label}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>
        )}
        
        {step === 'result' && result && (
          <div className="section-padding">
            <h1 className="title text-center">{result.description.title}</h1>
            
            <div className="grid grid-cols-4 gap-2 mb-8">
              {['EI', 'SN', 'TF', 'JP'].map((dimension) => {
                const scores = result.dimensionScores[dimension];
                const total = scores[dimension[0]] + scores[dimension[1]];
                const firstPercent = Math.round((scores[dimension[0]] / total) * 100);
                const secondPercent = 100 - firstPercent;
                
                return (
                  <div key={dimension} className="result-dimension">
                    <div className="dimension-labels">
                      <span>{dimension[0]}</span>
                      <span>{dimension[1]}</span>
                    </div>
                    <div className="dimension-bar">
                      <div 
                        className="dimension-fill" 
                        style={{ width: `${firstPercent}%` }}
                      />
                    </div>
                    <div className="dimension-percentage">
                      {firstPercent}% : {secondPercent}%
                    </div>
                  </div>
                );
              })}
            </div>
            
            <div className="result-card">
              <p className="result-description">{result.description.description}</p>
              
              <div className="result-grid">
                <div className="traits-section">
                  <h3 className="traits-title">강점</h3>
                  <ul className="traits-list">
                    {result.description.strengths.map((strength, idx) => (
                      <li key={idx} className="traits-item">{strength}</li>
                    ))}
                  </ul>
                </div>
                <div className="traits-section">
                  <h3 className="traits-title">약점</h3>
                  <ul className="traits-list">
                    {result.description.weaknesses.map((weakness, idx) => (
                      <li key={idx} className="traits-item">{weakness}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
            
            <div className="action-buttons">
              <button 
                onClick={() => changeStep('intro')} 
                className="btn btn-secondary"
              >
                처음으로
              </button>
              
              <button 
                onClick={startTest} 
                className="btn btn-primary"
              >
                다시 테스트하기
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="footer">
        <p>© 2025 MBTI 판별기 - 당신의 성격 유형을 더 잘 이해하세요</p>
      </div>
    </div>
  );
}

export default App;